<app-scheduler-filter-view
  [props]="filterViewProps"
  [rigResourceDateSource]="rigResources"
  [peopleResourceDataSource]="peopleResources"
></app-scheduler-filter-view>
